<div matDialogTitle>
    {{ body }}
</div>

<app-dialog-footer
    (buttonClick)="onClickClose(true)"
    (closeClick)="onClickClose(false)"
    posButtonText="Confirm"
></app-dialog-footer>
